module.exports = __webpack_public_path__ + "img/delete--black.987b5c5d.svg";